import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/api/client";
import { HardHat, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        localStorage.removeItem("app_token");
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        localStorage.removeItem("app_token");
        // Clean URL fragment
        window.history.replaceState({}, document.title, "/dashboard");
        // Force reload so AuthContext re-checks with fresh cookie
        window.location.href = data.role === "worker" ? "/objects" : "/dashboard";
      } catch (e) {
        setErr("Не удалось завершить вход. Попробуйте ещё раз.");
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#0b0f17] grain-bg flex items-center justify-center px-6">
      <div className="text-center">
        <div className="w-14 h-14 rounded-lg bg-amber-500/15 border border-amber-500/40 flex items-center justify-center mx-auto mb-5">
          <HardHat className="text-amber-400" size={26} />
        </div>
        {err ? (
          <>
            <div className="text-red-400 font-medium mb-3">{err}</div>
            <a href="/login" className="text-amber-400 hover:underline text-sm">Вернуться на вход</a>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2 justify-center text-slate-300 font-display font-semibold text-lg">
              <Loader2 className="animate-spin" size={18} /> Завершаем вход через Google…
            </div>
            <div className="text-slate-500 text-xs mt-2">Одну секунду</div>
          </>
        )}
      </div>
    </div>
  );
}
